export const createBackupPayload = ({
  tasks,
  companies,
  healthSettings,
  soundSettings,
  prayerStatus,
  userName,
  userPhoto,
  userRole,
  currentUser,
  workspaceUsers,
  authSession,
  syncConnection,
  syncQueue,
  workspaceName,
  currentWorkspace,
  governorate,
  theme,
  lang
}) => ({
  tasks,
  companies,
  healthSettings,
  soundSettings,
  prayerStatus,
  userName,
  userPhoto,
  userRole,
  currentUser,
  workspaceUsers,
  authSession,
  syncConnection,
  syncQueue,
  workspaceName,
  currentWorkspace,
  governorate,
  theme,
  lang
});

export const createBackupFilename = (date = new Date()) => (
  `flowdesk_backup_${date.toISOString().split('T')[0]}.json`
);

export const parseBackupJson = (jsonText, defaultSoundSettings) => {
  const data = JSON.parse(jsonText);

  return {
    tasks: Array.isArray(data.tasks) ? data.tasks : undefined,
    companies: data.companies || undefined,
    healthSettings: data.healthSettings || undefined,
    soundSettings: data.soundSettings ? { ...defaultSoundSettings, ...data.soundSettings, adhanType: 'full' } : undefined,
    prayerStatus: data.prayerStatus || undefined,
    userName: data.userName,
    userPhoto: data.userPhoto,
    userRole: data.userRole,
    currentUser: data.currentUser,
    workspaceUsers: Array.isArray(data.workspaceUsers) ? data.workspaceUsers : undefined,
    authSession: data.authSession,
    syncConnection: data.syncConnection,
    syncQueue: Array.isArray(data.syncQueue) ? data.syncQueue : undefined,
    workspaceName: data.workspaceName,
    currentWorkspace: data.currentWorkspace,
    governorate: data.governorate,
    theme: data.theme
  };
};
